/**
 * ReadyGatePanel — Stichproben-Gate-Hinweis im „Bereit"-Tab (T8, Plan-Zeile
 * 137-144). Zähler-Badge statt Ring (kein Custom-CSS — Tailwind/`Badge`).
 * `total` ist die aktuell geladene Seite (die API liefert kein Gesamt-`total`,
 * s. `NeedsReviewList.tsx`-Kommentar) — ausreichend als Stichproben-Bezug,
 * da die Stichprobe ohnehin auf sichtbare Zeilen wirkt.
 */
import { useTranslation } from 'react-i18next'

import { Badge } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

import { sampleGateMin, isGateOpen } from './sampleGate'

export function ReadyGatePanel({ checkedCount, total }: { checkedCount: number; total: number }) {
  const { t } = useTranslation()
  const min = sampleGateMin(total)
  const open = isGateOpen(checkedCount, total)

  return (
    <div
      id={EID['text-bulk-ready-gate-region']}
      className="flex items-center gap-3 rounded-lg border border-neutral-200 bg-neutral-50 p-3 dark:border-neutral-800 dark:bg-neutral-900"
    >
      <Badge variant={open ? 'success' : 'default'} size="md">
        {t('channelContent.ready.sampleGateProgress', { checked: Math.min(checkedCount, min), min })}
      </Badge>
      {!open && (
        <p className="text-sm text-neutral-600 dark:text-neutral-400">
          {t('channelContent.ready.sampleGate', { min, total })}
        </p>
      )}
    </div>
  )
}
